import { Injectable } from '@angular/core';
import { CountryInterface } from '@app/core/interfaces';
import * as fromCountry from '@app/store/my-zone/country/country.selectors';
import * as fromMyZone from '@app/store/my-zone/my-zone';
import { select, Store } from '@ngrx/store';
import { NotificationInterface } from 'outshared-lib';
import { Observable } from 'rxjs';

/**
 * @deprecated use OutCountriesModule from outshared-lib
 */
@Injectable({
    providedIn: 'root',
})
export class CountrySelectorService {
    public getCountries$: Observable<CountryInterface[]> = this.store.pipe(select(fromCountry.getEntities));
    public getErrors$: Observable<NotificationInterface[]> = this.store.pipe(select(fromCountry.getErrors));
    public isLoaded$: Observable<boolean> = this.store.pipe(select(fromCountry.isLoaded));
    public isLoading$: Observable<boolean> = this.store.pipe(select(fromCountry.isLoading));

    constructor(private store: Store<fromMyZone.State>) {}
}
